import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const ChevronIcon = createSvgIcon(
  <path
    d="M8 10L12 14L16 10"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="transparent"
  />,
  "ChevronIcon"
);
